import ENV from "../env";
import { buildHeaders, handleExpiredLogin } from "./utils";

/** Mirrors the backend's DefinitionResponse. */
export type WorkoutDefinition = {
    id: string;
    title: string;
    /** The heading the workout is listed under in the catalogue. */
    group: string;
    topics: string[];
    tags: string[];
    size: number;
    rate: number;
    answers: number;
};

export class WorkoutDefinitionsService {
    static workoutDefinitions(): Promise<WorkoutDefinition[]> {
        return fetch(`${ ENV.BACKEND }/workout-definitions`, {
            method: 'GET',
            headers: buildHeaders()
        })
            .then((response) => handleExpiredLogin(response).json());
    }
}
